export const TOGGLE_DEVICE = 'TOGGLE_DEVICE'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const EXPAND_MENU = 'EXPAND_MENU'

export const SWITCH_EFFECT = 'SWITCH_EFFECT'

export const UPDATE = 'UPDATE'

export const DELETE = 'DELETE'

export const CREATE = 'CREATE'

export const MAKE_DELETE_MESSAGE = 'MAKE_DELETE_MESSAGE'
export const ACCEPT_DELETE = 'ACCEPT_DELETE'
export const REJECT_DELETE = 'REJECT_DELETE'
